// import "cordova-plugin-camera";
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { currentWidget } from '../../../action/action';
import { setIdCardImage, setIdCardImageBack, setIdRotateDeg, setSelectedIdType, setCheckinWidgetLaunchTime, setCheckinCurrentPageName } from '../../action/autoCheckin';
import Header from '../header/header';
import PicturePreview from './PicturePreview';
import Camera from './Camera';
import closeIcon from '../../images/icons/close_icon.svg';
import { setGoHome } from '../../action/homeAction'
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import {withTranslation} from 'react-i18next'
import SelectDropdown from '../../UI/SelectDropdown';
import { closeOrderPopUp } from '../../action/hCommerce2'
import { sendAnalytics } from "../../../action/homeAction"
import { getDefaultAnalyticsLabel, generateToken } from '../../JS/utility';
import { CLICKED, IDCARD_DEMO, DEMO, CMSPath } from '../../../config/constant';

class CameraModule extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      imageUrl: '',
      imageBackUrl: '',
      test: '',
      error: '',
      new_data: '',
      data: '',
      showPicturePreview: false,
      profile:null ,
      cameraPrev:false,
      showErrorScreen:false,
      isFront:false,
      supportedIdTypes:[
        {
          idType: "Passport"
        },
        {
          idType: "Driving License"
        }
      ],
      showIdList: false,
      selectedId: null,
    }
    this.cameraSuccess = this.cameraSuccess.bind(this);
  }

  componentDidUpdate(){
    mobileCheckinColorConfig(this.props.menuColor);
    console.log("this.props.guestDocOptions",this.props.guestDocOptions)
  }

  componentDidMount() {

    if(this.props.selectedIdType){
      this.setState({selectedId: this.props.selectedIdType.value})
    } else {
      let makeDefaultIndex = this.props.guestDocOptions.findIndex((options) => options.isDefault == true)
      if(makeDefaultIndex >= 0){
        this.setState({selectedId: this.props.guestDocOptions[makeDefaultIndex].value})
        this.props.setSelectedIdType(this.props.guestDocOptions[makeDefaultIndex]);
      }
    }

    console.log("this.props.currentWidgetObj.widgetType",this.props.currentWidgetObj.widgetType)

    const checkinSessionToken = localStorage.getItem("checkinSessionToken");
    const checkin_id_capture_event_sent = localStorage.getItem("checkin_id_capture_event_sent");

    // Send Analytics
    let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})

    if(!checkin_id_capture_event_sent){
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "ID CARD - CAPTURE", 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "ID CARD - CAPTURE", "widgetSessionId": checkinSessionToken}, 
          0, 
          false, // guest is not logged in
          () => localStorage.setItem("checkin_id_capture_event_sent", true)
      );
    }
    this.props.setCheckinCurrentPageName("ID CARD - CAPTURE")
    //

  }

  cameraSuccess(imageUri) {
    // imageUrl: `data:image/jpeg;base64,${base}`,
    if(this.props.selectedIdType){
      if(!this.state.isFront && this.props.selectedIdType.bothSideImageRequired){
        this.setState({
          imageBackUrl: `${imageUri}`,
          showBackPicturePreview: true 
        })
        this.props.setIdCardImageBack({imageUrl: `${imageUri}`});  
      } else {
        this.setState({
          imageUrl: `${imageUri}`,
          showPicturePreview: true 
        })
        this.props.setIdCardImage({imageUrl: `${imageUri}`});
      }
    } else {
      this.props.closeOrderPopUp(true, "Please select the id type", "", true)
    }
  }

  // (this.state.isFront) 
  // && this.state.imageUrl 
  // && ((this.props.selectedIdType.bothSideImageRequired && this.state.imageBackUrl) || !this.props.selectedIdType.bothSideImageRequired ) 
  // &&

  render() {
    const {t} = this.props
    return (

      this.state.cameraPrev && this.props.selectedIdType ? 
      <Camera isFront={this.state.isFront} bothSideImageRequired={this.props.selectedIdType.bothSideImageRequired} idCapture={true} heading="Guest Check In" 
      nextScreen={ this.props.setSelfieScreen} 
      switchUsingNextScreen={((this.props.selectedIdType.bothSideImageRequired && this.props.idCardImageBack && this.props.idCardImage) || (!this.props.selectedIdType.bothSideImageRequired && this.props.idCardImage))}
      nextPath={'/checkin'} selfie = {false} 
      saveImage = {this.cameraSuccess} image = { this.state.isFront ? this.state.imageUrl : this.state.imageBackUrl } backBtn = {() => this.setState({cameraPrev:false})}
      click_single_picture={true} hidePicturePreview = {() => this.setState({cameraPrev: false})} selectedId={this.state.selectedId} />

      :<div id="myStay" className="main-container widgets booking-page" style={{background: '#fff'}}>
          {/* <Header bgImage={false} /> */}
          <header className="inner-pages w-footer subpages ">
            <a onClick = {() => {
              // this.props.setGoHome(true);
              this.props.setSelectedIdType(null);
              this.props.setIdCardImage(null)
              this.props.setIdCardImageBack(null)
              this.props.goBack()
            }} className="button-back"></a>
            <div className="heading align-center">
              <div class="splash-brand">
                  <img src={`${CMSPath}${this.props.logo}`} />
              </div>
              {/* <p className="bold" style = {{color:"inherit"}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
            </div>
          </header>
          <section className="widgets padding-0 margin-0 container-bg">

            <div class="widget-header widget-header-checkin-inner">
                { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                    </div>
                }
                <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
            </div>

            <div className="widgets">
              <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                <h2 className = "all-caps"></h2>
              </div>
              <div className="form-window">
                <div className="form-window-heading">
                {t('check_in.personal_info')}
                </div>
                <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                <div class="form-row">
                  <label>Type of ID</label>
                  <SelectDropdown 
                    selectKey="obj.value"
                    selectedItem={this.state.selectedId}
                    listData={this.props.guestDocOptions}
                    showList={this.state.showIdList}
                    setShowList={() => {
                      this.setState(prev => ({showIdList: !prev.showIdList}))
                    }}
                    setSelectedItem={(obj) => {
                      this.setState({selectedId: obj.value, showIdList:false})
                      this.props.setSelectedIdType(obj);
                      this.props.setIdCardImage(null)
                      this.props.setIdCardImageBack(null)
                    }}
                  />
                  </div>
                  {!this.props.idCardImage ? 
                    <div className="form-row margin-bottom-2">
                      <label>{t('check_in.scan_id')} <text style={{color: 'red'}} >*</text></label>
                      <div onClick={() => {
                        this.props.selectedIdType ? this.setState({cameraPrev:true, isFront:true}) : this.props.closeOrderPopUp(true, "Please select the id type", "", true)
                        /*if (navigator.camera){
                          var srcType = navigator.camera.PictureSourceType.CAMERA;
                          var options = this.setOptions(srcType); 
                          navigator.camera.getPicture(this.cameraSuccess, this.cameraFailure, options);
                        }*/
                      }}>
                        <label for="scanId" className="photo-uploader">
                          { (this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired) ? "Take a photo of the front of your ID"
                                  : "Take a photo of your ID"}
                        </label>
                      </div>
                    </div>
                  
                    : <div style = {{background:"#000", height: "300px",marginBottom:'20px',position:'relative',overflow:"hidden"}}>
                      <img src = {closeIcon} className = "id_image_delete_icon" onClick = {() => this.props.setIdCardImage(null)} style={{position: 'absolute',top: '10px',right: '10px',width: '20px',zIndex: '5'}}/>
                      <img src = {`${this.props.idCardImage.imageUrl}`} height = "100%" width = "100%" style = {{marginBottom: '10px',objectFit: 'contain', transform: `rotate(${this.props.idRotateDeg}deg)`}}/>
                    </div>}

                    {!this.props.idCardImageBack && (this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired) && <div className="form-row margin-bottom-2">
                      <div onClick={() => {
                        this.setState({cameraPrev:true, isFront:false});
                      }}>
                      <label for="scanId" className="photo-uploader">Take a photo of the back of your ID</label>
                      </div>
                    </div>}

                  {this.props.idCardImageBack && <div style = {{background:"#000", height: "300px",marginBottom:'20px',position:'relative',overflow:"hidden"}}>
                    <img src = {closeIcon} className = "id_image_delete_icon" onClick = {() => this.props.setIdCardImageBack(null)} style={{position: 'absolute',top: '10px',right: '10px',width: '20px',zIndex: '5'}}/>
                    <img src = {`${this.props.idCardImageBack.imageUrl}`} height = "100%" width = "100%" style = {{marginBottom: '10px',objectFit: 'contain', transform: `rotate(${this.props.idRotateDeg}deg)`}}/>
                  </div>}
                  <div className="form-controls">
                    {/* <Link exact to = "/checkin/selfie"> */}
                      <button onClick={this.props.setSelfieScreen} className="primary w-100" disabled = { (this.state.selectedId == "Driving License" || this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired) ?
                                                                      !this.props.idCardImage || !this.props.idCardImageBack ? true : false
                                                                      : !this.props.idCardImage ? true : false}>
                      {t('check_in.next')}
                      </button>
                    {/* </Link> */}
                    <button className="secondary w-100 margin-top-1" onClick = {() => {
                      // this.props.setGoHome(true);
                      this.props.setIdCardImage(null);
                      this.props.setIdCardImageBack(null);
                      this.props.goBack()
                    }}>{t('check_in.prev')}</button>
                  </div>
                  { DEMO && <button className="secondary w-100 margin-top-1" onClick = {this.props.skip}>SKIP</button>}
                </div>
              </div>
            </div>
          </section>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    selectedIdType: state.store2.selectedIdType,
    idCardImage: state.store2.idCardImage,
    idCardImageBack: state.store2.idCardImageBack,
    idRotateDeg: state.store2.id_rotate_deg,
    menuColor: state.store.home.MenuColor,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDocOptions: state.store.guestDocOptions
  }
}
export default connect(
  mapStateToProps,
  {
    currentWidget,
    setIdCardImage,
    setIdCardImageBack,
    setGoHome,
    closeOrderPopUp,
    setSelectedIdType,
    sendAnalytics,
    setCheckinWidgetLaunchTime,
    setCheckinCurrentPageName
  }
)(withTranslation('translations')(CameraModule));
